<template>
  <b-modal ref="modal" title="Create New Admin">
    <b-form @submit.prevent="submit">
      <validation-summary :errors="errors"></validation-summary>
      <v-form-group :validator="$v.email" label="Email">
        <b-form-input 
          slot-scope="{ attrs, listeners }"
          v-bind="attrs"
          v-on="listeners"
          v-model="email" 
          placeholder="Email" 
        />
      </v-form-group>
    </b-form>
    <div slot="modal-footer">
      <b-btn @click="cancel" variant="outline-secondary">Cancel</b-btn>
      <b-btn :loading="loading" variant="success" @click="submit">Create</b-btn>
    </div>
  </b-modal>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

import adminService from "services/admin-service";
import modalFormMixin from "mixins/modal-form-mixin";

export default {
  mixins: [modalFormMixin],

  data() {
    return {
      email: ""
    };
  },

  validations: {
    email: {
      required,
      email
    }
  },

  methods: {
    async onSubmit() {
      await adminService.create(this.email);
    }
  }
};
</script>